import React from 'react'
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/react/outline'

const Pagination = (props) => {
  return (
    <div className="flex items-center gap-3">
        <div>{props.currentPage} dari {props.maxPage} halaman</div>
        {props.currentPage > 1 && 
          <span onClick={() => props.changePage(props.currentPage - 1)} className="p-2 rounded-lg cursor-pointer hover:bg-slate-50">
              <ChevronLeftIcon className='w-6 h-6'/>
          </span>
        }
        {props.currentPage < props.maxPage &&
          <span onClick={() => props.changePage(props.currentPage + 1)} className="p-2 rounded-lg cursor-pointer hover:bg-slate-50">
              <ChevronRightIcon className='w-6 h-6'/>
          </span>
        }
    </div>
  )
}

export default Pagination